import React from 'react';
import * as PropTypes from 'prop-types';
import { Link } from '../../router';

import { classNamer } from '../../lib/utils';

const cn = classNamer('Breadcrumb');

import './Breadcrumb.scss';

const Breadcrumb = ({ items }) => {
  return (
    <div className={cn('container', items.length === 2 ? 'small' : 'large')}>
      {items.map((item, i) => (
        <>
          {i !== 0 && <span className={cn('item', 'separator')}>&gt;</span>}
          <div className={cn('item')}>
            <Link route={item.to}>
              <a>{item.label}</a>
            </Link>
          </div>
        </>
      ))}
    </div>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.array.isRequired,
};

export default Breadcrumb;
